import React from 'react'

import classes from './BuildControls.css'
import BuildControl from './BuildControl/BuildControl'

const controls = [
    { label: "Patty", type: "patty" },
    { label: "Cheese", type: "cheese" },
    { label: "Salad", type: "salad" },
    { label: "Paneer Tikka", type: "paneer-tikka" },
]

const buildControls = (props) => (
    <div className={classes.BuildControls}>
        <p>Current Price: <strong>{props.price.toFixed(2)}</strong></p>
        {controls.map(ctrl => (
            <BuildControl
                key={ctrl.label}
                label={ctrl.label}
                added={() => { props.ingredientAdded(ctrl.type) }}
                removed={() => { props.ingredientRemoved(ctrl.type) }}
                disabled={props.disabled[ctrl.type]} />
        ))}
        <button
            className={classes.OrderButton}
            disabled={!props.purchasable}
            onClick={props.ordered}>{props.isAuth ? 'ORDER NOW!' : 'Login to Order'}</button>
    </div>
)

export default buildControls


// WEBPACK FOOTER //
// ./src/components/Burger/BuildControls/BuildControls.js